import axiosInstance from './api'
import {
	fixtureFetchStudentLorRequests,
	shouldUseApplicationFlowFixtures,
} from 'fixtures/applicationFlowFixtures'

export const fetchStudentLorBragsheet = async studentId => {
	const { data } = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/bragsheet`,
	)
	return data
}

export const fetchStudentLorRequests = async (studentId, applicationTargetId = null) => {
	if (shouldUseApplicationFlowFixtures()) {
		return fixtureFetchStudentLorRequests(studentId, applicationTargetId)
	}

	const query = applicationTargetId
		? `?applicationTargetId=${encodeURIComponent(applicationTargetId)}`
		: ''
	const { data } = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/requests${query}`,
	)
	return data
}

export const downloadStudentLorFile = async (studentId, fileId) => {
	const res = await axiosInstance.get(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/files/${encodeURIComponent(fileId)}/download`,
		{ responseType: 'blob' },
	)
	return res.data
}

export const uploadCounselorLorExternal = async (studentId, formData) => {
	const { data } = await axiosInstance.post(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/external/upload`,
		formData,
		{ headers: { 'Content-Type': 'multipart/form-data' } },
	)
	return data
}

export const uploadCounselorLorReceivedForRequest = async (studentId, requestId, file) => {
	const fd = new FormData()
	fd.append('file', file)
	const { data } = await axiosInstance.post(
		`/counseling/students/${encodeURIComponent(studentId)}/lor/requests/${encodeURIComponent(requestId)}/received-lor`,
		fd,
		{ headers: { 'Content-Type': 'multipart/form-data' } },
	)
	return data
}
